import { CustomerRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * customerOnUpdateData - Function that updates on database an existing customer by id  
 * /customers/{id}  
 * method PUT  
 * @async-function
 */
const customerOnUpdateData = async (token: string, model: CustomerRequestType, id: number) => {
    const response = await api.put(
        `/customers/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default customerOnUpdateData;